<template>
  <div>
    <zone-form
      v-if="showForm"
      :is-new="false"
    />
  </div>
</template>

<script>
import { onUnmounted, ref } from '@vue/composition-api'
import ZoneForm from './components/ZoneForm.vue'
import zoneStoreModule from '@/views/zones/zoneStoreModule'
import store from '@/store'
import router from '@/router'

export default {
  components: {
    ZoneForm,
  },
  setup() {
    const SERVICE_APP_STORE_MODULE_NAME = 'zones'

    // Register module
    if (!store.hasModule(SERVICE_APP_STORE_MODULE_NAME)) {
      store.registerModule(SERVICE_APP_STORE_MODULE_NAME, zoneStoreModule)
    }
    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SERVICE_APP_STORE_MODULE_NAME)) store.unregisterModule(SERVICE_APP_STORE_MODULE_NAME)
    })
    const showForm = ref(true)
    if (!store.getters['zones/selectedZone']) {
      showForm.value = false
      router.push('/zones-services')
    }
    return {
      showForm,
    }
  },
}
</script>
